import { Box, Text } from '@src/shared/ui';
import React from 'react';

type AlertTicketProps = {
  className?: string;
};

export const AlertTicket: React.FC<AlertTicketProps> = ({ className }) => {
  return (
    <Box
      className={`
        col-span-8
        md:col-start-8
        md:col-span-5
        bg-alert-10
        mt-6
        md:mt-10
        text-left
        px-6
        py-4
        rounded-2xl
        flex-row
        items-start
        gap-3
        md:mb-20
        ${className}
      `}
    >
      <Box>
        <img
          src='/alert-circle.svg'
          className='max-w-[24px] min-w-[24px] min-h-[24px] max-h-[24px]'
          alt='Ícone de alerta'
        />
      </Box>
      <Text className='text-neutral-70 font-normal text-sm sm:text-base leading-5'>
        A compensação do boleto pode levar até 3 dias úteis, dependendo da forma
        de pagamento escolhida.
      </Text>
    </Box>
  );
};
